// extracted by mini-css-extract-plugin
export const globalNav = "header-module--globalNav--1Gh3z";
export const globalNavFrame = "header-module--globalNavFrame--1hvFK";
export const companyLogoFrame = "header-module--companyLogoFrame--2xzU2";
export const companyLogo = "header-module--companyLogo--2MZpF";
export const navigationFrame = "header-module--navigationFrame--nXhhN";
export const menuList = "header-module--menuList--28Ght";
export const menuItem = "header-module--menuItem--3F78_";
export const menuListBtn = "header-module--menuListBtn--3Hl_k";